import { ReactNode } from 'react';

import { AddBox, DeleteSweep } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';

import { formRowsStyles } from './FormRows.styles';

export interface StaticRowProps {
  onDelete?: () => void;
  onAdd?: () => void;
  children: ReactNode;
  isFull?: boolean;
  isHierarchyContext?: boolean;
}

export const StaticRow = ({
  children,
  onDelete,
  onAdd,
  isFull,
  isHierarchyContext,
}: StaticRowProps) => (
  <Box sx={formRowsStyles.container}>
    {children}
    {(onDelete || onAdd) && (
      <Box>
        {onDelete && (
          <IconButton
            data-testid="delete-static-row"
            onClick={onDelete}
            sx={formRowsStyles.button}
            size="large"
          >
            <DeleteSweep />
          </IconButton>
        )}
        {onAdd && !isHierarchyContext && (
          <IconButton
            data-testid="add-static-row"
            onClick={onAdd}
            sx={formRowsStyles.button}
            disabled={isFull}
            size="large"
          >
            <AddBox />
          </IconButton>
        )}
      </Box>
    )}
  </Box>
);
